module.exports = __webpack_public_path__ + "images/Match_Group-baa669.png";